import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const orders = 'Orders'

export const getOrders = (filters, headers = {}) => {
    return axios.post(`/${orders}/PaginatedAndFiltered`, filters, { headers })
}

export const getOrder = (id, level, headers = {}) => {
    return axios.get(`/${orders}/${id}/${level}`, { headers })
}

export const acceptOrder = (data) => {
    return axios.put(`/${orders}`, data)
}

export const uploadOrderInvoice = (data) => {
    return axios.post(`/${orders}/Invoices`, data)
}

export const downloadOrderInvoice = (id, level) => {
    return axios.get(`/${orders}/Invoices/${id}/${level}`)
}